<template>
  <fragment>
    <div class="row" v-if="entity">
      <div class="col-lg-12 col-xl-3">
        <div class="card m-b-30">
          <div class="card-body">
            <div
              class="nav flex-column nav-pills"
              id="v-pills-product-tab"
              role="tablist"
              aria-orientation="vertical"
            >
              <a
                class="nav-link mb-2 active"
                id="v-pills-general-tab"
                data-toggle="pill"
                href="#v-pills-general"
                role="tab"
                aria-controls="v-pills-general"
                aria-selected="true"
              >
                <i class="feather icon-info mr-2"></i>Generale
              </a>
              <a
                class="nav-link mb-2"
                id="v-pills-execution-tab"
                data-toggle="pill"
                href="#v-pills-execution"
                role="tab"
                aria-controls="v-pills-execution"
                aria-selected="false"
              >
                <i class="feather icon-play mr-2"></i>Esecuzione
              </a>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-12 col-xl-9">
        <div class="card m-b-30">
          <div class="card-body">
            <div class="tab-content" id="v-pills-product-tabContent">
              <div
                class="tab-pane fade show active"
                id="v-pills-general"
                role="tabpanel"
                aria-labelledby="v-pills-general-tab"
              >
                <form @submit.prevent="save" v-if="entity">
                  <div class="row">
                    <div class="col-12">
                      <div class="form-group">
                        <label class="col-form-label" for="descrizione"
                          >Descrizione</label
                        >
                        <input
                          type="text"
                          class="form-control required"
                          id="descrizione"
                          name="descrizione"
                          placeholder="Descrizione macro"
                          v-model="entity.description"
                        />
                      </div>
                    </div>
                    <div class="col-12">
                      <label class="col-form-label" for="query">Query</label>
                      <input
                        type="text"
                        class="form-control required"
                        id="query"
                        name="query"
                        placeholder="ricerca"
                        v-model="entity.macroConfiguration.searchQuery"
                      />
                    </div>
                    <div class="col-10">
                      <label class="col-form-label">Tag di ricerca</label>
                      <taglist
                        v-model="entity.macroConfiguration.searchTags"
                        :exclude="['allegati']"
                      ></taglist>
                    </div>

                    <div class="col-2">
                      <label class="col-form-label">Operatore</label>
                      <select
                        class="form-control"
                        v-model="entity.macroConfiguration.searchOperation"
                      >
                        <option value="AND">AND</option>
                        <option value="OR">OR</option>
                      </select>
                    </div>
                    <div class="col-10">
                      <label class="col-form-label"
                        >Tag di assegnazione/rimozioni</label
                      >
                      <taglist
                        v-model="entity.macroConfiguration.actionTags"
                        :exclude="['allegati']"
                      ></taglist>
                    </div>

                    <div class="col-2">
                      <label class="col-form-label">Azione</label>
                      <select
                        class="form-control"
                        v-model="entity.macroConfiguration.action"
                      >
                        <option value="INSERT">Inserimento</option>
                        <option value="REMOVE">Rimozione</option>
                      </select>
                    </div>
                  </div>

                  <div class="form-group mt-3">
                    <button
                      type="button"
                      class="btn btn-xs btn-primary-rgba mr-2"
                      v-on:click="save"
                    >
                      Salva
                      <font-awesome-icon
                        :icon="['far', 'save']"
                      ></font-awesome-icon>
                    </button>
                    <button
                      type="button"
                      class="btn btn-xs btn-danger-rgba mr-2"
                      v-on:click="cancel"
                    >
                      Annulla
                      <font-awesome-icon
                        :icon="['far', 'times-circle']"
                      ></font-awesome-icon>
                    </button>
                  </div>
                </form>
              </div>
              <div
                class="tab-pane fade"
                id="v-pills-execution"
                role="tabpanel"
                aria-labelledby="v-pills-execution-tab"
              >
                <div class="row">
                  <div class="col-12">
                    <button
                      type="button"
                      class="btn btn-block btn-info-rgba m-1 mb-5"
                      v-on:click="loaddata"
                    >
                      Anteprima dati
                    </button>

                     <table ref="table" id="list-company-table" class="table w-100"></table>
                      <button
                      type="button"
                      class="btn btn-block btn-info-rgba m-1 mt-5"
                      v-on:click="executeMacro"
                    >
                      Esegui macro
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </fragment>
</template>

<script>
import Editor from "@tinymce/tinymce-vue";
import axios from "axios";
import { Chrome } from "vue-color";
import { Slider } from "vue-color";
export default {
  data() {
    return {
      entity: null,
      colors: "#FFFFFF",
    };
  },
  computed: {
    tinyKey: function () {
      return window.SETTINGS.TinyApiKey;
    },
  },
  components: {
    Editor,
    "chrome-picker": Chrome,
  },
  name: "TagTypeSave",
  beforeMount() {
    var me = this;

    axios.get("tag/macro/" + me.$route.params.id).then((response) => {
      me.entity = response.data;

      if (me.entity.description && me.entity.description != "") {
        me.$store.state.breadCrump.title = me.entity.description;
      }
    });
  },
  methods: {
    loaddata: function () {
      window["EditAction"] = this.edit;
      var me = this;

      var edit = "M";
      if (me.$refs && me.$refs.edit && me.$refs.edit.outerHTML) {
        edit = me.$refs.edit.outerHTML;
      }

      var remove = "C";
      if (me.$refs && me.$refs.remove && me.$refs.remove.outerHTML) {
        remove = me.$refs.remove.outerHTML;
      }
      if ($.fn.DataTable.isDataTable("#list-company-table")) {
        $("#list-company-table").DataTable().destroy();
      }

      var $table = $("#list-company-table").DataTable({
        searching: false,
        ordering: false,
        processing: true,
        serverSide: true,
        ajax: {
          url: window.SETTINGS.apiUrl + "/company/list",
          type: "POST",
          data: function (d) {
           
            d.search.value = me.entity.macroConfiguration.searchQuery;
            d.tagOperator = me.entity.macroConfiguration.searchOperation;
            d.filters = [
              {
                key: "tags",
                value: JSON.stringify(me.entity.macroConfiguration.searchTags),
              },
            ];
            d.tago;

            return JSON.stringify(d);
          },

          beforeSend: function (request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + me.$store.state.user.token
            );
            request.setRequestHeader("Content-Type", "application/json");
          },
        },

        columns: [
          {
            data: "companyId",
            name: "companyId",
            title: "Codice",
            render: function (data, type, row, meta) {
              return row.internalCode;
            },
          },
          {
            data: "companyId",
            name: "companyId",
            title: "Azienda",
            render: function (data, type, row, meta) {
              return row.name;
            },
          }
        ],
      });
    },
executeMacro(){
    var me = this;
 me.$swal({
        title: ``,
        html: `Sicuri di eseguire la macro?`,
        type: "question",
        showCancelButton: true,
        confirmButtonClass: "btn-warning-rgba",
        confirmButtonText: "Procedi",
      }).then(function (isconfirm) {
        if (isconfirm.value) {
         axios.post("tag/macro/action/"+me.entity.macroId).then((response) => {
       me.$swal({
                title: "Macro eseguita  con successo",
                text: "",
                type: "success",
                showCancelButton: false,
                toast: true,
                timer: 2000,
                showConfirmButton: false,
                position: "bottom-top",
              });
        });
            
        }
      });

     
      }
    ,
    cancel() {
      this.$router.push({
        name: "route-macro-list",

        replace: true,
      });
    },
    save() {
      var me = this;
      axios.post("tag/macro", this.entity).then((response) => {
        me.$router.push({
          name: "route-macro-edit",
          params: { id: response.data.macroId },
          replace: true,
        });
         me.$swal({
                title: "Salvataggio avvenuto con successo",
                text: "",
                type: "success",
                showCancelButton: false,
                toast: true,
                timer: 2000,
                showConfirmButton: false,
                position: "bottom-top",
              });
       
      });
    },
  },
};
</script>
